import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonHLPure, DialogTemplatePure, TextAreaHLPure } from "../../pures";
import { Grid } from "@material-ui/core";
import "./dialog-sign.css";
import { useState } from "react";

const DialogRejectSignature = (props) => {
  const { t } = useTranslation();

  const [comments, setComments] = useState("");

  const handleChangeComments = (event) => {
    setComments(event.target.value);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    props.onSubmitReject({ comments });
  }

  return (
    <>
      {(props.userCanSign === true || props.authorizerCanSign === true) &&
        props.signatureRequest.signRequest.signRequestStatus.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING) ? (
        <div>
          {/* Button reject and display the dialog */}
          {/* <ButtonHLPure
            nameBtn={t("button.reject")}
            onClickBtn={props.toggleDialogReject}
          /> */}
          {props.visibleReject && (
            <DialogTemplatePure
              title={t("dialogRejectSignature.titleRejectSignRequest")}
              canelBtn={t("button.cancel")}
              cancel={props.toggleDialogReject}
              saveBtn={t("button.send")}
              handleSubmitProfile={handleSubmit}
              loadingComponent={props.showLoadingRequesting}
              saveError={props.showErrorRequesting}
            >
              <Grid
                container
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="dialogRejectSignature-titleRejectSignRequest-contaiiner"
              >
                {/* Input Teaxtarea */}
                <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
                  <TextAreaHLPure
                    labelTextArea={`${t("dialogRejectSignature.rejectRequest")} ${props.userRequestingSign}?`}
                    placeholder={t("dialogRejectSignature.reason")}
                    valueTextData={comments}
                    handleChangeTextArea={handleChangeComments}
                    rowsTextArea={4}
                    errorInput={props.errorTextArea}
                    errorTextArea={t("dialogRejectSignature.validTextArea")}
                  />
                </Grid>
              </Grid>
            </DialogTemplatePure>
          )}
        </div>
      ) : null}
    </>
  );
};

export { DialogRejectSignature as default };
